

export const TaxFields = [

    { key: 'id', label: 'Tax ID' },
    { key: 'description', label: 'Description' },
    {
        key: 'type',
        label: 'Type',
        options: [
            { value: 1, label: 'Sales' },
            { value: 2, label: 'Purchase' },
        ],
        map: { 1: 'Sales', 2: 'Purchase' },
        type: 'select'
    },
    { key: 'percent', label: 'Tax Percent', type: 'number', min: 0, max: 100 },
    { key: 'addressOne', label: 'Address Line 1', type: 'text' },
    { key: 'addressTwo', label: 'Address Line 2', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'state', label: 'State', type: 'text' },
    { key: 'zip', label: 'Zip Code', type: 'number' },
    { key: 'phone', label: 'Phone', type: 'text' },
    { key: 'fax', label: 'Fax', type: 'text' },

    {
        key: 'useTax',
        label: 'Use Tax',
        type: 'checkbox'
    },

    {
        key: 'useAsDefault',
        label: 'Default Tax',

        type: 'checkbox'
    },
    {
        key: 'isNoTaxProposal',
        label: 'No Tax on Proposal',

        type: 'checkbox'
    },
    { key: 'useTaxPercent', label: 'Use Tax Percent', type: 'number', min: 0, max: 100 },
    { key: 'postingAccountID', label: 'Posting Account ID', type: 'number' },
];


export const GeneralInfoFields = [


    { key: 'description', label: 'Description' },
    {
        key: 'type',
        label: 'Type',
        options: [
            { value: 1, label: 'Sales' },
            { value: 2, label: 'Purchase' },
        ],
        map: { 1: 'Sales', 2: 'Purchase' },
        type: 'select'
    },
    { key: 'percent', label: 'Tax Percent', type: 'number', min: 0, max: 100 },


    {
        key: 'useTax',
        label: 'Use Tax',

        type: 'checkbox'
    },

    {
        key: 'useAsDefault',
        label: 'Default Tax',

        type: 'checkbox'
    },
    {
        key: 'isNoTaxProposal',
        label: 'No Tax on Proposal',

        type: 'checkbox'
    },
    { key: 'useTaxPercent', label: 'Use Tax Percent', type: 'number', min: 0, max: 100 },
    { key: 'postingAccountID', label: 'Posting Account ID', type: 'number' },
];

export const AddressInfoFields = [
    { key: 'addressOne', label: 'Address Line 1', type: 'text' },
    { key: 'addressTwo', label: 'Address Line 2', type: 'text' },
    { key: 'city', label: 'City', type: 'text' },
    { key: 'state', label: 'State', type: 'text' },
    { key: 'zip', label: 'Zip Code', type: 'number' },
    { key: 'phone', label: 'Phone', type: 'text' },
    { key: 'fax', label: 'Fax', type: 'text' }
];

export const defaultTaxFormData = {
    id: null,
    description: '',
    type: 1,
    percent: 0,
    addressOne: '',
    addressTwo: '',
    city: '',
    state: '',
    zip: '',
    phone: '',
    fax: '',
    useTax: false,
    useAsDefault: false,
    isNoTaxProposal: false,
    useTaxPercent: 0,
    postingAccountID: null
};
